export enum HubSpotEnrichmentJobChangeIntegrationModeEnum {
  CREATE_NEW = "CREATE_NEW",
  UPDATE_OLD = "UPDATE_OLD",
}
